import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { BurdenContainerComponent } from './burden-container/burden-container.component';
import { BurdenFiltersContainerComponent } from './burden-filters-container/burden-filters-container.component';
import { BurdenFiltersPresenterComponent } from './burden-filters-presenter/burden-filters-presenter.component';
import { BurdenPresenter } from './burden-presenter/burden-presenter.component';
import { BurdenRoute } from './burden.route';

@NgModule({
    declarations: [
        BurdenContainerComponent,
        BurdenPresenter,
        BurdenFiltersContainerComponent,
        BurdenFiltersPresenterComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [BurdenRoute]
        })
    ]
})
export class BurdenModule {}
